import ControllersDetails from "./controllersDetails";

export default ControllersDetails;
